const GOOGLEANALYTICS_TRACKINGCODE = 'UA-1638034-20';

import hotkey from '@/Data/Functions/hotkey';

(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

ga('create', GOOGLEANALYTICS_TRACKINGCODE, 'auto');
ga('send', 'pageview');

export default {
    name: 'app',
    components: {
        PageHeader: () => import(/* webpackChunkName: "COMPONENT___PageHeader" */'@/components/PageHeader/PageHeader'),
        headerComponent: () => import(/* webpackChunkName: "COMPONENT___Header" */ '@/globalComponents/header/header'),
        HotkeyPopup: () => import(/* webpackChunkName: "COMPONENT___HotkeyPopup" */ '@/components/HotkeyPopup/HotkeyPopup'),
        ProductSearchPopup: () => import(/* webpackChunkName: "COMPONENT___ProductSearchPopup" */ '@/components/ProductSearchPopup/ProductSearchPopup'),
        ChangeSaveIndicator: () => import(/* webpackChunkName: "COMPONENT___ChangeSaveIndicator" */'@/components/ChangeSaveIndicator/ChangeSaveIndicator'),
        BrowserBanner: () => import(/* webpackChunkName: "COMPONENT___BrowserBanner" */ '@/components/BrowserBanner/BrowserBanner')
    },
    data() {
        return {
            overlayHotkeyCode: ''
        };
    },
    mounted() {
        this.overlayHotkeyCode = hotkey.HOTKEYEVENTS.filter(e => e.name === 'Overlay')[0].keyString;
    },
    methods: {
        forceReloadPage() {
            window.location.reload(true);
        }
    }
};
